import { render } from "./HelpModal.vue?vue&type=template&id=50ec18e2&scoped=true"
import script from "./HelpModal.vue?vue&type=script&lang=js"
export * from "./HelpModal.vue?vue&type=script&lang=js"

import "@/assets/css/components/HelpModal.scss?vue&type=style&index=0&id=50ec18e2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ec18e2"]])

export default __exports__